import React from 'react';
import { Link } from 'react-router-dom'
import styled from "styled-components";

const Wrapper = styled.div`
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;
`

const StyledComponentLink = styled(Link)`
    font-size: 0.8rem;
    text-decoration: none;
    color: black;

    :hover{
        color: ${props => props.theme.codanColors.codanBlue};
    }    
`

const BottomNavLink = ({
    links,
    ...props
}) => {
    const renderLinks = (links) => {
        return links.map((link, i) => {
            return (
                <StyledComponentLink
                    key={i}
                    to={link.to}
                >
                    {link.text}
                </StyledComponentLink>
            )
        })
    }

    return (
        <Wrapper>
            {renderLinks(links)}
        </Wrapper>
    )
}

export default BottomNavLink;